// Takes a number and converts it into a currency string including dollar sign and commas for thousands.
// e.g. 1234 -> $1,234
// e.g. 1234.56 -> $1,234.56
export function formatAsCurrency(num, keepNonZeroDecimals = true) {
  const formatted = num.toLocaleString('en-US', {
    currency: 'USD',
    style: 'currency',
    maximumFractionDigits: 2,
  });

  const parts = formatted.split('.');

  if (!keepNonZeroDecimals && parts[1] === '00') {
    return parts[0];
  }

  return formatted;
}

// Adds commas to a big number and rounds to the nearest whole number
// e.g. 1000.9 -> 1,001
export function formatNumber(num) {
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}

export default {formatAsCurrency, formatNumber};
